export class PUCATDataReq {
  constructor(
    public categoryId: number,
    public categoryType: string,
    public categoryName: string,
    public categoryOrder: number,
    public deleted: boolean
  ) {}
}

export class PostUpsertCategoryReq {
  constructor(
    public data: PUCATDataReq[]
  ) {
  }
}
